import { WorkflowsRoutePath } from "#src/routes/workflows";
import { RoutePath } from "#src/utils/route";

export const WorkflowTasksRoutePath = WorkflowsRoutePath.concat(
  new RoutePath({
    path: "/new/tasks",
    title: "Tasks",
  })
);
